// import logo from './logo.svg';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import Bills from './components/Bills';
import Layout from './components/Layout/layout';
import Dashboard from './components/dashboard/Dashboard';
import { Helmet } from "react-helmet"
import TopBarProgress from "react-topbar-progress-indicator";
import { useState } from 'react';
import UserLayout from './layout/UserLayout';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import BillerDash from './components/dashboard/BillerDash';
import Confirm from './components/Auth/Confirm';
import PaymentRequest from './components/Home/PaymentRequest';
import PrivacyPolicy from './components/footer/PrivacyPolicy';
import Support from './views/app/support';
import SalesSupport from './views/app/sales-support';
import GovernmentMda from './views/app/government-mda';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function App() {

  const [loading,setLoading]= useState(false);

  TopBarProgress.config({
    barColors: {
      "0": "blue",
      "1.0": "red"
    },
    shadowBlur: 5
  });
  return (
    <>
      <Helmet>
          <script
            src="https://pay-service.icadpay.com/host/new-inline-stage-pay.js"
            async
          ></script>
      </Helmet>
      
      {loading && <TopBarProgress /> }
      <ToastContainer
        position="top-right"
        autoClose={7000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Routes>
        <Route path='/' element={<Layout/>}>
          <Route path='/' element={<Home/>}/>
          <Route path='bills' element={<Bills/>}/>
          <Route path='gov-mda' element={<GovernmentMda/>}/>
          <Route path='/contact' element={<Support/>}/>
          <Route path='/contact/support' element={<Support/>}/>
          <Route path='contact/sales' element={<SalesSupport/>}/>
          <Route path='payrequest/:uniqueRef' element={<PaymentRequest load={setLoading}/>}/>
          <Route path='/register' element={<Register/>}/>
          <Route path='*' element={<Home/>}/>
          
          <Route path='/dashboard' element={<Dashboard load={setLoading}/>}>
            <Route path=':biller' element={<Dashboard/>} />
          </Route>
          <Route path='/dashboard/nipost' element={<BillerDash load={setLoading} billerType="nipost"/>}>
         
          </Route>
          <Route path='/dashboard/gov-mda' element={<BillerDash load={setLoading} billerType="gov-mda"/>}></Route>
        </Route>
        <Route path='/user' element={<UserLayout/>}>
          <Route path='/user/login' element={<Login/>}/>
          <Route path='/user/register' element={<Register/>}/>
          <Route path='/user/privacy-policy' element={<PrivacyPolicy/>}/>
          <Route path='/user/confirm-account/:id' element={<Confirm/>}/>
        </Route>
      </Routes>
    </>
  );
}

export default App;
